import {gtag, loadGoogleTagManager as loadGtm, syncCrossPseudoIdWithGa4} from "@pg-mono/google-tag-manager";

import {gtmId, gtmLoadUrl, gtmScriptId, gtmScriptParams, gtmUrl} from "../../km_app/utils/read_environment_variables";

declare global {
    interface Window {
        dataLayer: object[];
    }
}

export const initGoogleTagManager = (): void => {
    // Configure GA4 cross-domain linker before GTM loads the GA4 tag.
    // Auto-decorates <a href> clicks between km and rp with the `_gl` param.
    gtag("set", "linker", {domains: ["rynekpierwotny.pl", "kontomieszkaniowe.pl"], decorate_forms: true, accept_incoming: true});

    syncCrossPseudoIdWithGa4().catch(() => undefined);

    loadGtm({
        containerId: gtmId,
        gtmUrl: gtmUrl,
        gtmLoadUrl: gtmLoadUrl,
        scriptId: gtmScriptId,
        scriptParams: gtmScriptParams
    });
};

// Config
interface IConfigGTM {
    viewType: string | null;
}

export const configureGoogleTagManager = (config: IConfigGTM): void => {
    const win = window as Window;

    // initialize only in browser
    if (process.env.EXEC_ENV !== "browser") {
        return;
    }

    interface IGtmGroup {
        pageType: string;
    }

    // on page load run script to group future content sent do GTM
    (function (w: Window, dataLayer: "dataLayer") {
        w[dataLayer] = w[dataLayer] || [];
        const gtmData: IGtmGroup = {
            pageType: config.viewType != null ? config.viewType : "na"
        };
        w[dataLayer].push(gtmData);
    })(win, "dataLayer");
};
import {gtag, loadGoogleTagManager as loadGtm, syncCrossPseudoIdWithGa4} from "@pg-mono/google-tag-manager";

import {gtmId, gtmLoadUrl, gtmScriptId, gtmScriptParams, gtmUrl} from "../../km_app/utils/read_environment_variables";

declare global {
    interface Window {
        dataLayer: object[];
    }
}

export const initGoogleTagManager = (): void => {
    // Configure GA4 cross-domain linker before GTM loads the GA4 tag.
    // Auto-decorates <a href> clicks between km and rp with the `_gl` param.
    gtag("set", "linker", {domains: ["rynekpierwotny.pl", "kontomieszkaniowe.pl"], decorate_forms: true, accept_incoming: true});

    syncCrossPseudoIdWithGa4().catch(() => undefined);

    loadGtm({
        containerId: gtmId,
        gtmUrl: gtmUrl,
        gtmLoadUrl: gtmLoadUrl,
        scriptId: gtmScriptId,
        scriptParams: gtmScriptParams
    });
};

// Config
interface IConfigGTM {
    viewType: string | null;
}

export const configureGoogleTagManager = (config: IConfigGTM): void => {
    const win = window as Window;

    // initialize only in browser
    if (process.env.EXEC_ENV !== "browser") {
        return;
    }

    interface IGtmGroup {
        pageType: string;
    }

    // on page load run script to group future content sent do GTM
    (function (w: Window, dataLayer: "dataLayer") {
        w[dataLayer] = w[dataLayer] || [];
        const gtmData: IGtmGroup = {
            pageType: config.viewType != null ? config.viewType : "na"
        };
        w[dataLayer].push(gtmData);
    })(win, "dataLayer");
};
